import { render, staticRenderFns } from "./ChatAnnouncementsFeed.vue?vue&type=template&id=9019656a&scoped=true"
import script from "./ChatAnnouncementsFeed.vue?vue&type=script&lang=js"
export * from "./ChatAnnouncementsFeed.vue?vue&type=script&lang=js"
import style0 from "./ChatAnnouncementsFeed.vue?vue&type=style&index=0&id=9019656a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9019656a",
  null
  
)

export default component.exports